export enum UserState {
  Active = "Active",
  Inactive = "Inactive",
  InvitationExpired = "InvitationExpired",
  Invited = "Invited"
}

export interface UserDetailsModel {
  userId: string;
  displayName: string;
  firstName: string;
  lastName: string;
  preferredLanguage: string;
  email: string;
  state: UserState;
  invitationExpiration: Date;
}
